import {$window} from '../Constants';
import HtmlElementsStack from '../Elements/HtmlElementsStack';

// import special HtmlElements
import Banner from '../Elements/Banner';
import Header from '../Elements/Header';
import MainMenu from '../Elements/MainMenu';
import HorizontalSubMenu from '../Elements/HorizontalSubMenu';
import MetaMenu from '../Elements/MetaMenu';
import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import Tiles from '../Elements/Tiles';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 */
class PageController {

	constructor() {
		// Object containing special elements that inherit from HtmlElement
		// relevant page events are delegated to these objects through the controller
		this.htmlElementsStack = new HtmlElementsStack(
			Banner,
			Header,
			MainMenu,
			HorizontalSubMenu,
			BackToTopButton,
			MetaMenu,
			ContentSlider,
            Tiles
		);
	}

	onReady() {
		// pass ready event to HtmlElements
		this.onEvent('onReady');
		this.bindEventListeners();
	}

	onEvent(fn, e = {}) {
		// pass event to HtmlElements
		this.htmlElementsStack.forEachCallFunction(fn, e);
	}

	bindEventListeners() {
		$window.on({
			'load': e => {this.onEvent('onLoad', e)},
			'scroll': e => {this.onEvent('onScroll', e)},
			'resize': e => {this.onEvent('onResize', e)},
		});
	}
}

export default (new PageController);